export const sojernConfigs = {
  brentwood: {
    propertyID: "41928",
  },
  // Add more properties here in future
};

/**
 * 
 * @param {string} [hpr='PaliHotel'] - Hotel Property name (default is 'Laguna Beach Lodge').
 * @param {string} hpid - Hotel Property ID.
 * @param {"TRACKING" | "HOME_PAGE" | "PRODUCT"} pt - Page type for tracking.
 */
export function renderSojernScript(hpr = 'Laguna Beach Lodge', hpid, pt) {
    const scriptContent = `
      (function () {
        var params = {
          hpr: "${hpr}", /* Hotel Property */
          hpid: "${hpid}", /* Property ID */
          sha256_eml: "", /* Hashed Email SHA256 */
          sha1_eml: "", /* Hashed Email SHA1 */
          md5_eml: "", /* Hashed Email MD5 */
          ccid: "", /* Client Cookie id */
          pt: "${pt}" /* Page Type - CONVERSION or HOME_PAGE or PRODUCT or SEARCH or SHOPPING_CART or TRACKING */
        };
  
        /* Please do not modify the below code. */
        params.et = {"HOME_PAGE":null,"SEARCH":"hs","PRODUCT":"hpr","SHOPPING_CART":"hcart","CONVERSION":"hc","TRACKING":null}[params.pt] || '';
        try { params = Object.assign({}, sjrn_params, params); } catch(e) {}
        var paramsArr = [];
        for (var key in params) {
          paramsArr.push(key + '=' + encodeURIComponent(params[key]));
        }
  
        var pl = document.createElement('iframe');
        pl.type = 'text/html';
        pl.setAttribute('style','height:0; width: 0; display:none;');
        pl.async = true;
        pl.src = "https://static.sojern.com/cip/c/11.html?f_v=cp_v3_js&p_v=1&" + paramsArr.join('&');
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(pl);
      })();
    `;

    return (
        <>
            <script src='https://static.sojern.com/utils/sjrn_autocx.js'></script>
            <script
                dangerouslySetInnerHTML={{
                    __html: scriptContent,
                }}
            />
        </>
    );
}
